package com.arenaproplay.admin.ui.components.notifications

import androidx.compose.runtime.*
import kotlin.js.Date

data class ToastData(
    val id: Double = Date.now(),
    val message: String,
    val type: ToastType = ToastType.INFO,
    val duration: Long = 3000L
)

enum class ToastType {
    SUCCESS, ERROR, INFO, WARNING
}

class ToastState {
    private val _toasts = mutableStateListOf<ToastData>()
    val toasts: List<ToastData> get() = _toasts

    fun show(message: String, type: ToastType = ToastType.INFO, duration: Long = 3000L) {
        _toasts.add(ToastData(message = message, type = type, duration = duration))
    }

    fun success(message: String, duration: Long = 3000L) {
        show(message, ToastType.SUCCESS, duration)
    }

    fun error(message: String, duration: Long = 4000L) {
        show(message, ToastType.ERROR, duration)
    }

    fun warning(message: String, duration: Long = 3500L) {
        show(message, ToastType.WARNING, duration)
    }

    fun info(message: String, duration: Long = 3000L) {
        show(message, ToastType.INFO, duration)
    }

    fun dismiss(id: Double) {
        _toasts.removeAll { it.id == id }
    }
}

val LocalToastState = compositionLocalOf<ToastState> {
    error("ToastState not provided. Wrap your content with ProvideToast.")
}

@Composable
fun rememberToastState(): ToastState {
    return remember { ToastState() }
}

@Composable
fun ProvideToast(
    toastState: ToastState = rememberToastState(),
    content: @Composable () -> Unit
) {
    CompositionLocalProvider(LocalToastState provides toastState) {
        content()
        ToastContainer(toastState)
    }
}
